import React from 'react';

const HANDLE_RE = /^[a-z0-9]+([._-][a-z0-9]+)+$/i;

const prettyHandle = (value) => String(value || '')
    .split(/[._-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');

/** Readable name for the suggestion row. The @token that gets inserted stays the username. */
export const mentionDisplayName = (user) => {
    const named = String(user?.displayName || '').trim();
    const handle = String(user?.username || (user?.email || '').split('@')[0] || '').trim();
    if (named && !named.includes('@') && !HANDLE_RE.test(named)) return named;
    const label = prettyHandle(handle || named);
    return label || user?.email || 'User';
};

const MentionSuggestions = ({ users, onSelect, inline = false }) => {
    if (!users || users.length === 0) return null;
    return (
        <div className={`mention-suggestions-dropdown${inline ? ' is-inline' : ''}`} role="listbox" aria-label="People you can mention">
            {users.map((user, idx) => {
                const name = mentionDisplayName(user);
                const email = user.email || '';
                const department = user.department || user.dept || '';
                const key = email || user.username || idx;
                return (
                    <div
                        key={key}
                        className="mention-suggestion"
                        role="option"
                        onMouseDown={(ev) => {
                            ev.preventDefault();
                            ev.stopPropagation();
                            onSelect(user);
                        }}
                    >
                        <span className="mention-suggestion-name">{name}</span>
                        {department ? <span className="mention-suggestion-dept">{department}</span> : null}
                        {email ? <span className="mention-suggestion-email">{email}</span> : null}
                    </div>
                );
            })}
        </div>
    );
};

export default MentionSuggestions;
